import { REPORTS_MEDICINE_WISE_STOCK_TRANSFER } from "../../framework/tab/tabUtilsConstants";
import moment from "moment";
import { dateFilterComparator } from "../../utils/utils";
export const columnDefs = [
  {
    headerName: "Stock Transfer ID",
    field: "stockTransferId",
    width: 150,
  },
  {
    headerName: "Stock Request ID",
    field: "stockRequestId",
    width: 150,
  },
  {
    headerName: "From Branch ID",
    field: "fromBranchId",
    width: 150,
  },
  {
    headerName: "To Branch ID",
    field: "toBranchId",
    width: 150,
  },
  {
    headerName: "Batch Number",
    field: "batch",
    width: 150,
  },
  {
    headerName: "Product ID",
    field: "productId",
    width: 150,
  },
  {
    headerName: "Product Name",
    field: "productName",
    width: 250,
  },
  {
    headerName: "MRP",
    field: "mrp",
    width: 150,
  },
  {
    headerName: "Packaging",
    field: "packaging",
    width: 150,
  },
  {
    headerName: "Expiry",
    field: "expiry",
    width: 180,
  },
  {
    headerName: "Requested Quantity",
    field: "requestedQuantity",
    width: 180,
  },
  {
    headerName: "Transfered Quantity",
    field: "transferedQuantity",
    width: 180,
  },
  {
    headerName: "Stock Request Date and time",
    field: "stockRequestDateTime",
    width: 200,
  },
  {
    headerName: "Stock Transfer Date and time",
    field: "stockTransferDateTime",
    width: 200,
  },
  {
    headerName: "Transferrred By",
    field: "transferredBy",
    width: 150,
  },
  {
    headerName: "Effective CP",
    field: "effectiveCp",
    width: 150,
  },
  {
    headerName: "Fullfillment Status",
    field: "fullfillmentStatus",
    width: 190,
  },
  {
    headerName: "Transfer Reason",
    field: "transferReason",
    width: 150,
  },
  {
    headerName: "Status",
    field: "status",
    width: 150,
  },
  {
    headerName: "Remarks",
    field: "remarks",
    width: 150,
  },
];
export const columnDefsFunctions = {
  expiry: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
  stockRequestDateTime: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
  stockTransferDateTime: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
  status: {
    cellStyle: (params) => {
      return {
        borderRight: "1px solid #a0a0a0",
        ...(params.value === "ACCEPTED" && { color: "green" }),
        ...(params.value === "REJECTED" && { color: "red" }),
        ...(params.value !== "ACCEPTED" &&
          params.value !== "REJECTED" && { color: "black" }),
      };
    },
  },
};

export const initial_state_medicine_wise_stock_transfer_report = {
  type: REPORTS_MEDICINE_WISE_STOCK_TRANSFER,
  label: "Medicine Wise Stock Transfer Report",
  allowMultipleTabs: false,
};
